import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';


@NgModule({
    declarations: [],
    imports: [
        BrowserAnimationsModule,
        MatDialogModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatRadioModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatInputModule,
        MatTabsModule,
        MatIconModule
    ],
    exports: [
        BrowserAnimationsModule,
        MatDialogModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatRadioModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatInputModule,
        MatTabsModule,
        MatIconModule
    ]
})
export class MaterialModule {
}
